import React from "react";
import classes from "./MatchEvents2.module.css";
import { useTranslation } from "react-i18next";

const MatchEvents2 = ({ team_name, data }) => {
    const {t}=useTranslation();
    return (
        <div className={classes.panel_container}>
            <div className={classes.panel_header}>
                <p className={classes.panel_header_heading}>{team_name}</p>
            </div>
            {data?.length > 0 ? (
                data.map((dataItem, index) => (
                    <div className={classes.container} key={index}>
                        <p className={classes.name}>{dataItem?.player?.name}</p>
                        <p className={classes.time}>{dataItem?.time?.elapsed}`</p>
                    </div>
                ))
            ) : (
                <p className={classes.empty}>{t("208")}</p>
            )}
        </div>
    );
};

export default MatchEvents2;